module.exports = __webpack_public_path__ + "img/dice-3.13abbe59.svg";